<mat-expansion-panel *ngIf="Expandable" #panel class="expansion-panel-without-padding">
    <app-filter-card UnlimitedHeight #filter [Settings]="FilterSettings$ | async" [Values]="FilterValues$ | async" (ValuesChange)="FilterValues$.next($event)"></app-filter-card>


    <app-filter-card UnlimitedHeight #supplierfilter [Settings]="SupplierFilterSettings$ | async" [Values]="SupplierFilterValues$ | async" (ValuesChange)="SupplierFilterValues$.next($event)"></app-filter-card>

    <mat-expansion-panel-header class="card-headline" style="padding: 0 15px 0 7px">
        <div class="header-content">
            <fa-stack matCardAvatar>
                <fa-icon [icon]="MaterialPageMeta.Icon" stackItemSize="1x"></fa-icon>
            </fa-stack>
            <h3>Material</h3>
        </div>
        <div class="header-button-wrapper">
            <mat-form-field floatLabel="never" [class.invisible]="!searchVisible" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" style="width: 12rem">
                <mat-label>Suche</mat-label>
                <input matInput type="search" [formControl]="searchForm" #searchInput />
                <button class="clear-search" *ngIf="searchForm.value" mat-icon-button aria-label="Clear" (click)="searchForm.setValue('')">
                    <!--                        <fa-icon icon="times"></fa-icon>-->
                </button>
            </mat-form-field>
            <ng-container *ngIf="panel.expanded">
                <button *ngIf="!searchVisible && (materialListsGrouped$ | async)?.length && panel.expanded" app-round-button matTooltip="Zus. Spalten anzeigen" (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu">
                    <fa-icon icon="table-columns"></fa-icon>
                </button>
                <button *ngIf="panel.expanded" style="margin: auto 0 auto auto" app-round-button (click)="$event.stopPropagation(); toggleSearch()" [matTooltip]="searchVisible ? 'abbrechen' : 'suchen'">
                    <fa-icon [icon]="searchVisible ? 'times' : 'search'"></fa-icon>
                </button>
                <button *ngIf="!searchVisible && (hasMaterialLists$ | async) && panel.expanded && materialListTabIsActive" app-round-button class="header-button" [matBadge]="FilterAmount$ | async" [matBadgeHidden]="!(FilterAmount$ | async)" matTooltip="Filter" [matBadgeOverlap]="true" (click)="$event.stopPropagation(); filter.Open();">
                    <fa-icon icon="filter"></fa-icon>
                </button>
                <button *ngIf="!searchVisible && (hasMaterialToCommissions$ | async) && panel.expanded && deliveryNoteTabIsActive" app-round-button class="header-button" [matBadge]="SupplierFilterAmount$ | async" [matBadgeHidden]="!(SupplierFilterAmount$ | async)" matTooltip="Filter" [matBadgeOverlap]="true" (click)="$event.stopPropagation(); supplierfilter.Open();">
                    <fa-icon icon="filter"></fa-icon>
                </button>
                <button *ngIf="(hasMaterialToCommissions$ | async) && panel.expanded && deliveryNoteTabIsActive" app-round-button class="header-button" matTooltip="Drucken" [matMenuTriggerFor]="printMenu" (click)="$event.stopPropagation()">
                    <fa-icon icon="print"></fa-icon>
                </button>
            </ng-container>
            <button *ngIf="!dialogRef && !searchVisible" matTooltip="Vollbild" app-round-button (click)="openDialog(); $event.stopPropagation()">
                <fa-icon icon="expand"></fa-icon>
            </button>
        </div>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    </ng-template>
</mat-expansion-panel>
<div *ngIf="!Expandable" style="position: relative">
    <div class="card-headline" style="padding: 0 0.5rem 0 0.5rem">
        <div class="header-content">
            <h3>Material</h3>
        </div>
        <div class="header-button-wrapper" *ngIf="Expanded">
            <div class="header-button-wrapper">
                <mat-form-field floatLabel="never" [class.invisible]="!searchVisible" (click)="$event.stopPropagation()" style="width: 15rem; margin-right: 8px; height: auto">
                    <mat-label>Suche</mat-label>
                    <input matInput type="search" [formControl]="searchForm" #searchInput />
                    <button class="clear-search" *ngIf="searchForm.value" mat-icon-button aria-label="Clear" (click)="searchForm.setValue('')">
                        <fa-icon icon="times"></fa-icon>
                    </button>
                </mat-form-field>
                <app-filter-card UnlimitedHeight #filter [Settings]="FilterSettings$ | async" [Values]="FilterValues$ | async" (ValuesChange)="FilterValues$.next($event)"></app-filter-card>
                <app-filter-card UnlimitedHeight #supplierfilter [Settings]="SupplierFilterSettings$ | async" [Values]="SupplierFilterValues$ | async" (ValuesChange)="SupplierFilterValues$.next($event)"></app-filter-card>


                <button style="margin: auto 0 auto auto" app-round-button (click)="$event.stopPropagation(); toggleSearch()" [matTooltip]="searchVisible ? 'abbrechen' : 'suchen'">
                    <fa-icon [icon]="searchVisible ? 'times' : 'search'"></fa-icon>
                </button>


                <button *ngIf="!searchVisible && (hasMaterialLists$ | async) && materialListTabIsActive" app-round-button class="header-button" [matBadge]="FilterAmount$ | async" [matBadgeHidden]="!(FilterAmount$ | async)" matTooltip="Filter" [matBadgeOverlap]="true" (click)="filter.Open()">
                    <fa-icon icon="filter"></fa-icon>
                </button>

                <button *ngIf="!searchVisible && (hasMaterialToCommissions$ | async) && deliveryNoteTabIsActive" app-round-button class="header-button" [matBadge]="SupplierFilterAmount$ | async" [matBadgeHidden]="!(SupplierFilterAmount$ | async)" matTooltip="Filter" [matBadgeOverlap]="true" (click)="supplierfilter.Open()">
                    <fa-icon icon="filter"></fa-icon>
                </button>

                <button *ngIf="(hasMaterialToCommissions$ | async) && deliveryNoteTabIsActive" app-round-button class="header-button" matTooltip="Drucken" [matMenuTriggerFor]="printMenu">
                    <fa-icon icon="print"></fa-icon>
                </button>

                <button
                    *ngIf="PS.Has$(PS.Permissions.CreateLedgerImports) | async"
                    [matMenuTriggerFor]="documentTypeMenu"
                    app-round-button
                    class="header-button"
                    matTooltip="Material abrechnen"
                    matTooltipPosition="left"
                >
                    <app-double-icon [Icon]="ReportsPageMeta.Icon" Icon2="plus"></app-double-icon>
                </button>
                <mat-menu #documentTypeMenu="matMenu" class="wide-menu">
                    <button
                        (click)="$event.stopPropagation()"
                        class="create-arls-from-commission-info"
                        mat-menu-item
                        [matTooltip]="
                        'Diese Funktion sammelt alle bis zum jetzigen Zeitpunkt neuen Zeiten, Materialien und im Bautagebuch eingegeben Informationen zusammen macht einen Rechnungsvorschlag. Sollte es Informationen, zum Beispiel kein Bautagebuch geben, wird beispielsweise die Fahrtzone ignoriert.'
                    "
                    >
                        <fa-icon icon="info-circle" size="lg"></fa-icon>
                    </button>
                    <button mat-menu-item (click)="NewReport(false); $event.stopPropagation()">Es sollen die <strong>verbrauchten</strong> Materialien in die Rechnung einfließen.
                        <fa-icon [matTooltip]="'Unter Material werden verbrauchte Materialien angezeigt. Diese können manuell angelegt oder mit gebuchten Lieferscheinen automatisch erzeugt werden.'"
                                 data-html=true icon="info-circle" size="lg"></fa-icon>
                    </button>
                    <button mat-menu-item (click)="NewReport(true); $event.stopPropagation()">Es sollen die <strong>gebuchten</strong> Materialien in die Rechnung einfließen.
                        <fa-icon [matTooltip]="'Unter Material werden gebuchte Materialien (Soll-Wert) angezeigt, welche durch gebuchte Bestellungen automatisch erzeugt werden. .'" icon="info-circle" size="lg"></fa-icon>
                    </button>
                    <!-- SchlussRechnung, Abschlagsrechnung -->
                </mat-menu>
                <button *ngIf="!searchVisible && (materialListsGrouped$ | async)?.length" app-round-button matTooltip="Zus. Spalten anzeigen" [matMenuTriggerFor]="menu">
                    <fa-icon icon="table-columns"></fa-icon>
                </button>
                <button *ngIf="!searchVisible" app-round-button [matMenuTriggerFor]="addMenu" (click)="$event.stopPropagation()" matTooltip="Material zuweisen">
                    <app-double-icon [Icon]="MaterialPageMeta.Icon" Icon2="plus"></app-double-icon>
                </button>
                <mat-menu #addMenu>
                    <button (click)="openNewPopup()" mat-menu-item>
                        <fa-icon class="mat-icon" icon="plus"></fa-icon>
                        <span>Materialbedarf</span>
                    </button>
                    <button (click)="createMaterialToCommission()" mat-menu-item>
                        <fa-icon class="mat-icon" icon="plus"></fa-icon>
                        <span>Materialverbrauch</span>
                    </button>
                </mat-menu>
            </div>
        </div>
    </div>
    <ng-container [ngTemplateOutlet]="content"></ng-container>
    <ng-container [ngTemplateOutlet]="footer"></ng-container>
</div>

<ng-template #content>
    <mat-tab-group mat-align-tabs="center" (selectedTabChange)="onTabChange($event)">
        <mat-tab>
            <ng-template mat-tab-label>Material</ng-template>
            <div class="scroll-wrapper p-4">
                <mat-accordion  *ngIf="materialListsGrouped$ | async as materialListsGrouped; else loading">
                    <p *ngIf="!materialListsGrouped.length">
                        Keine Materialien vorhanden.
                    </p>
                    <mat-expansion-panel *ngFor="let material of materialListsGrouped" >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ material?.materialName }}
                            </mat-panel-title>
                            <mat-panel-description style="flex-grow: 0; flex-basis: unset"> {{ material.sum }} ({{ material.orderedSum }} bestellt) </mat-panel-description>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <ng-container *ngIf="material.orderLedgerImports$ | async as ledgerImports">
                                <p *ngIf="ledgerImports.length" class="mat-body-1 px-4" style="margin-bottom: 0.5rem">
                                    <ng-container *ngFor="let li of ledgerImports; first as first; last as last;">
                                        <span *ngIf="first">{{ ledgerImports.length > 1 ? 'Bestellungen:' : 'Bestellung:' }}&nbsp;</span>
                                        <a [routerLink]="LedgerImportRouterLinkPrefix+li.Id">{{li.ConsolidatedInvoiceId}}</a>
                                        <span *ngIf="!last">,&nbsp;</span>
                                    </ng-container>
                                </p>
                            </ng-container>
                            <table mat-table class="fixed-header" [dataSource]="material.materialLists$ | async">
                                <ng-container matColumnDef="ArticleNumber">
                                    <th mat-header-cell *matHeaderCellDef>Art-Nr.</th>
                                    <td mat-cell *matCellDef="let element">{{ element.ArticleNumber }}</td>
                                </ng-container>
                                <ng-container matColumnDef="SupplierName">
                                    <th mat-header-cell *matHeaderCellDef>{{cls.getSingle$('Supplier') | async}}</th>
                                    <td mat-cell *matCellDef="let element">{{ element.SupplierName }}</td>
                                </ng-container>
                                <ng-container matColumnDef="MaterialName" style="height: 2.3rem; overflow: hidden">
                                    <th mat-header-cell *matHeaderCellDef>Material</th>
                                    <td mat-cell *matCellDef="let element">{{ element.MaterialName }}</td>
                                </ng-container>
                                <ng-container matColumnDef="Quantity">
                                    <th mat-header-cell *matHeaderCellDef>Anzahl</th>
                                    <td mat-cell *matCellDef="let element">{{ element.Quantity }}</td>
                                </ng-container>
                                <ng-container matColumnDef="QuantityType">
                                    <th mat-header-cell *matHeaderCellDef>Einheit</th>
                                    <td mat-cell *matCellDef="let element">{{ element.QuantityType }}</td>
                                </ng-container>
                                <ng-container matColumnDef="CreatedAt">
                                    <th mat-header-cell *matHeaderCellDef>Datum</th>
                                    <td mat-cell *matCellDef="let element">{{ element.CreatedAt }}</td>
                                </ng-container>
                                <ng-container matColumnDef="Status">
                                    <th mat-header-cell *matHeaderCellDef>Status</th>
                                    <td mat-cell *matCellDef="let element">{{ element.Status }}</td>
                                </ng-container>
                                <ng-container matColumnDef="User">
                                    <th mat-header-cell *matHeaderCellDef>Bearbeiter</th>
                                    <td mat-cell *matCellDef="let element">{{ element.User }}</td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="MaterialColumns"></tr>
                                <tr mat-row *matRowDef="let rowData; columns: MaterialColumns"></tr>
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" [attr.colspan]="MaterialColumns?.length">
                                        <span>Keine Materialien vorhanden</span>
                                    </td>
                                </tr>
                            </table>
                        </ng-template>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>verbrauchtes Material</ng-template>
            <div class="scroll-wrapper p-4" *ngIf="materialToCommissions$ | async as materialToCommissions">
                <p *ngIf="materialToCommissions.length === 0">kein verbrauchtes Material vorhanden</p>

                <section class="article-block" *ngFor="let material of materialToCommissions">
                    <div class="article-header">
                        <div class="article-title">
                            <span class="article-number" *ngIf="material.ArticleNumber">{{ material.ArticleNumber }}</span>
                            <strong>{{ material.MaterialName }}</strong>
                        </div>
                        <span [class.app-foreground-warn]="(material.DeliverySum) > material.OrderedSum">{{ material.DeliverySum | number: '1.0-3' : 'de-DE' }} / {{ material.OrderedSum | number: '1.0-3' : 'de-DE' }}</span>
                        <button mat-icon-button matTooltip="Verbrauch anlegen" (click)="createMaterialToCommission(material)">
                            <fa-icon icon="plus"></fa-icon>
                        </button>
                    </div>

                    <table mat-table class="consumption-table" [dataSource]="material.m2cs">
                        <ng-container matColumnDef="Date">
                            <th mat-header-cell *matHeaderCellDef>Datum</th>
                            <td mat-cell *matCellDef="let element" [attr.title]="element.Date">{{ element.Date }}</td>
                            <td mat-footer-cell *matFooterCellDef><strong>Ergebnis</strong></td>
                        </ng-container>
                        <ng-container matColumnDef="SupplierName">
                            <th mat-header-cell *matHeaderCellDef>{{ cls.getSingle$('Supplier') | async }}</th>
                            <td mat-cell *matCellDef="let element" [attr.title]="element.SupplierName">{{ element.SupplierName }}</td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="DocumentType">
                            <th mat-header-cell *matHeaderCellDef>Dokumentenart</th>
                            <td mat-cell *matCellDef="let element" [attr.title]="element.DocumentType">{{ element.DocumentType }}</td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="Name">
                            <th mat-header-cell *matHeaderCellDef>Nummer</th>
                            <td mat-cell *matCellDef="let element" [attr.title]="element.Name">
                                <ng-container *ngIf="element.LedgerImportId; else normalText">
                                    <a [routerLink]="LedgerImportRouterLinkPrefix + element.LedgerImportId">{{ element.Name }}</a>
                                </ng-container>
                                <ng-template #normalText>{{ element.Name }}</ng-template>
                            </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="Description">
                            <th mat-header-cell *matHeaderCellDef>Bezeichnung</th>
                            <td mat-cell *matCellDef="let element" [attr.title]="element.Description">{{ element.Description }}</td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="Quantity">
                            <th mat-header-cell *matHeaderCellDef class="num">Menge</th>
                            <td mat-cell *matCellDef="let element" class="num" [attr.title]="element.Quantity">{{ element.Quantity | number: '1.0-3' : 'de-DE' }}
                            </td>
                            <td mat-footer-cell *matFooterCellDef class="num" [class.app-foreground-warn]="material.DeliverySum > material.OrderedSum">
                                <strong>{{ material.DeliverySum | number: '1.0-3' : 'de-DE' }}</strong>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="QuantityType">
                            <th mat-header-cell *matHeaderCellDef>Einheit</th>
                            <td mat-cell *matCellDef="let element" [attr.title]="element.QuantityType">{{ element.QuantityType }}</td>
                            <td mat-footer-cell *matFooterCellDef>{{ material.QuantityType }}</td>
                        </ng-container>
                        <ng-container matColumnDef="User">
                            <th mat-header-cell *matHeaderCellDef>Bearbeiter</th>
                            <td mat-cell *matCellDef="let element" [attr.title]="element.User">{{ element.User }}</td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="ArticleNumber">
                            <th mat-header-cell *matHeaderCellDef>Art-Nr.</th>
                            <td mat-cell *matCellDef="let element" [attr.title]="element.ArticleNumber">{{ element.ArticleNumber }}</td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="CostAmount">
                            <th mat-header-cell *matHeaderCellDef>EK-Preis</th>
                            <td mat-cell *matCellDef="let element" [attr.title]="element.CostAmount">{{ formatCurrency(element.CostAmount, 'de-DE', '€', 'EUR') }}</td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>
                        <ng-container matColumnDef="CostAmountSum">
                            <th mat-header-cell *matHeaderCellDef>Summe</th>
                            <td mat-cell *matCellDef="let element" [attr.title]="element.CostAmountSum">{{ formatCurrency(element.CostAmountSum, 'de-DE', '€', 'EUR') }}</td>
                            <td mat-footer-cell *matFooterCellDef class="num">
                                <strong>{{ formatCurrency(material.CostAmountSum, 'de-DE', '€', 'EUR') }}</strong>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="editButton">
                            <th mat-header-cell *matHeaderCellDef style="width: 40px"></th>
                            <td mat-cell *matCellDef="let element" style="width: 40px; text-overflow: unset">
                                <button *ngIf="!element.IsOrder" mat-icon-button (click)="editMaterialToCommission(element.MaterialToCommissionId)"><fa-icon icon="pencil-alt"></fa-icon></button>
                            </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="MaterialToCommissionColumns"></tr>
                        <tr mat-row *matRowDef="let rowData; columns: MaterialToCommissionColumns"></tr>
                        <tr mat-footer-row class="result-row" *matFooterRowDef="MaterialToCommissionColumns"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="MaterialToCommissionColumns.length">Keine Materialverbräuche vorhanden</td>
                        </tr>
                    </table>
                </section>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>verrechnetes Material</ng-template>
            <div class="scroll-wrapper p-4">
                <mat-accordion  *ngIf="materialListsPaid$ | async as materialListsGrouped; else loading">
                    <p *ngIf="!materialListsGrouped.length">
                        Keine Materialien vorhanden.
                    </p>
                    <mat-expansion-panel *ngFor="let material of materialListsGrouped;">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ material?.materialName }}
                            </mat-panel-title>
                            <mat-panel-description style="flex-grow: 0; flex-basis: unset"> {{ material.sum }} ({{ material.paidSum }} bezahlt) </mat-panel-description>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                            <ng-container *ngIf="material.orderLedgerImports$ | async as ledgerImports">
                                <p *ngIf="ledgerImports.length" class="mat-body-1 px-4" style="margin-bottom: 0.5rem">
                                    <ng-container *ngFor="let li of ledgerImports; first as first; last as last;">
                                        <span *ngIf="first">{{ ledgerImports.length > 1 ? 'Bestellungen:' : 'Bestellung:' }}&nbsp;</span>
                                        <a [routerLink]="LedgerImportRouterLinkPrefix+li.Id">{{li.ConsolidatedInvoiceId}}</a>
                                        <span *ngIf="!last">,&nbsp;</span>
                                    </ng-container>
                                </p>
                            </ng-container>
                            <table mat-table class="fixed-header" [dataSource]="material.materialLists$ | async">
                                <ng-container matColumnDef="ArticleNumber">
                                    <th mat-header-cell *matHeaderCellDef>Art-Nr.</th>
                                    <td mat-cell *matCellDef="let element">{{ element.ArticleNumber }}</td>
                                </ng-container>
                                <ng-container matColumnDef="SupplierName">
                                    <th mat-header-cell *matHeaderCellDef>{{cls.getSingle$('Supplier') | async}}</th>
                                    <td mat-cell *matCellDef="let element">{{ element.SupplierName }}</td>
                                </ng-container>
                                <ng-container matColumnDef="MaterialName" style="height: 2.3rem; overflow: hidden">
                                    <th mat-header-cell *matHeaderCellDef>Material</th>
                                    <td mat-cell *matCellDef="let element">{{ element.MaterialName }}</td>
                                </ng-container>
                                <ng-container matColumnDef="Quantity">
                                    <th mat-header-cell *matHeaderCellDef>Anzahl</th>
                                    <td mat-cell *matCellDef="let element">{{ element.Quantity }}</td>
                                </ng-container>
                                <ng-container matColumnDef="QuantityType">
                                    <th mat-header-cell *matHeaderCellDef>Einheit</th>
                                    <td mat-cell *matCellDef="let element">{{ element.QuantityType }}</td>
                                </ng-container>
                                <ng-container matColumnDef="CreatedAt">
                                    <th mat-header-cell *matHeaderCellDef>Datum</th>
                                    <td mat-cell *matCellDef="let element">{{ element.CreatedAt }}</td>
                                </ng-container>
                                <ng-container matColumnDef="Status">
                                    <th mat-header-cell *matHeaderCellDef>Status</th>
                                    <td mat-cell *matCellDef="let element">{{ element.Status }}</td>
                                </ng-container>
                                <ng-container matColumnDef="User">
                                    <th mat-header-cell *matHeaderCellDef>Bearbeiter</th>
                                    <td mat-cell *matCellDef="let element">{{ element.User }}</td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="MaterialColumns"></tr>
                                <tr mat-row *matRowDef="let rowData; columns: MaterialColumns"></tr>
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" [attr.colspan]="MaterialColumns?.length">
                                        <span>Keine Materialien vorhanden</span>
                                    </td>
                                </tr>
                            </table>
                        </ng-template>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </mat-tab>
    </mat-tab-group>
</ng-template>
<ng-template #footer>
    <mat-dialog-actions class="actions" *ngIf="Expanded">
        <button app-button Inverted mat-dialog-close Color="cancel">schließen</button>
    </mat-dialog-actions>
</ng-template>

<mat-menu #printMenu="matMenu">
    <button mat-menu-item (click)="PrintMaterialToCommissions('portrait')">
        <fa-icon class="mat-icon" icon="file"></fa-icon>
        <span> Hochformat (A4)</span>
    </button>
    <button mat-menu-item (click)="PrintMaterialToCommissions('landscape')">
        <fa-icon class="mat-icon" icon="file" [rotate]="90"></fa-icon>
        <span> Querformat (A4)</span>
    </button>
</mat-menu>

<mat-menu #menu="matMenu">
    <!--                    <button mat-menu-item (click)="toggleColumn('Lieferant')">-->
    <!--                        {{ visibility.Lieferant ? 'Lieferant anzeigen' : 'Lieferant ausblenden' }}-->
    <!--                    </button>-->
    <button mat-menu-item (click)="toggleColumn('Status')">
        {{ visibility.Status ? 'Status anzeigen' : 'Status ausblenden' }}
    </button>
    <button mat-menu-item (click)="toggleColumn('User')">
        {{ visibility.User ? 'Bearbeiter anzeigen' : 'Bearbeiter ausblenden' }}
    </button>
</mat-menu>

<ng-template #pagedSelectTest let-formControl="formControl">
    <mat-form-field style="width: 100%">
        <app-select-search-paged-options
            [placeholder]="MaterialEntity.EntityName"
            [formControl]="formControl"
            [Options]="materialOptions$ | async"
            [CompareOptions]="compareById"
            (searchChange)="materialOptionsSearchChange($event, paginator)"
            [OptionTemplate]="optionTemplate"
        >
            <mat-paginator option-list-footer #paginator [pageSize]="pageSize$ | async" [length]="_materialPageService.selectLength$ | async" (page)="materialOptionsPageChange($event)"></mat-paginator>
        </app-select-search-paged-options>
    </mat-form-field>
    <ng-template #optionTemplate let-option>
        {{ option.DisplayName }}
    </ng-template>
</ng-template>
<ng-template #loading><app-loading></app-loading></ng-template>
